import { UNDERLINE_KEY } from '@techchange/pm-specs';
import { toggleMark } from 'prosemirror-commands';

/**
 * Toggles the underline mark.
 *
 * @param {Object} state     The current editor state.
 * @param {Object} dispatch  The editor dispatch.
 *
 * @returns {boolean} Whether or not the command was successful.
 *
 */
export const toggleUnderline = (state, dispatch) => {

	const underlineMarkType = state.schema.marks[UNDERLINE_KEY];

	return toggleMark(underlineMarkType)(state, dispatch);

};
